"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateFilter = exports.decodeDateRange = exports.encodeDateRange = exports.defaultDateTimeDisplay = exports.defaultDateDisplay = void 0;
var moment_1 = __importDefault(require("moment"));
exports.defaultDateDisplay = 'MMM D YYYY';
exports.defaultDateTimeDisplay = 'MMM D YYYY h:mm A';
/**
 *
 * @param format a valid Moment date format specifier string
 * @param greaterThanEqual the lower value of the date range
 * @param lessThanEqual the higher value of the date range
 * @returns a stringified version of the range that can be passed to the AntD table dropdown
 */
var encodeDateRange = function (format, greaterThanEqual, lessThanEqual) {
    return JSON.stringify({
        '<=': lessThanEqual,
        '>=': greaterThanEqual,
        format: format,
    });
};
exports.encodeDateRange = encodeDateRange;
/**
 * Decodes the JSON stringified date range into something usable by our AntD table dropdown
 * @param encodedRange a stringified version of the range that can be passed to the AntD table dropdown
 * @returns a simple array of Moment values representing the lower and higher ends of the range
 */
var decodeDateRange = function (encodedRange) {
    var decoded = JSON.parse(encodedRange);
    return [
        decoded['>='] ? (0, moment_1.default)(decoded['>='], decoded.format) : undefined,
        decoded['<='] ? (0, moment_1.default)(decoded['<='], decoded.format) : undefined,
    ];
};
exports.decodeDateRange = decodeDateRange;
var dateFilter = function (columnName) { return function (value, record) {
    var _a;
    var filterVal = value;
    var rawObj = JSON.parse(filterVal);
    var dateFormat = rawObj === null || rawObj === void 0 ? void 0 : rawObj.format;
    var rangeDates = (_a = (0, exports.decodeDateRange)(filterVal)) !== null && _a !== void 0 ? _a : [];
    var greaterThanEqual = rangeDates[0], lessThanEqual = rangeDates[1];
    if (lessThanEqual) {
        var diff = (0, moment_1.default)(record[columnName], dateFormat).diff(lessThanEqual);
        var isLessThan = diff <= 0;
        if (!isLessThan) {
            return false;
        }
    }
    if (greaterThanEqual) {
        var diff = greaterThanEqual.diff((0, moment_1.default)(record[columnName], dateFormat));
        var isGreaterThan = diff <= 0;
        if (!isGreaterThan) {
            return false;
        }
    }
    return true;
}; };
exports.dateFilter = dateFilter;
//# sourceMappingURL=tableExtensionsUtils.js.map